import { memo, useCallback } from 'react';
import { Modal, StackNavigationProp, useNavigation } from '@bonanza-social/navigation';
import { Box, Button, Text } from '@bonanza-social/moonlight';
import { DuplicateAccountsBottomSheetProps } from './DuplicateAccountsBottomSheet.types';

function DuplicateAccountsBottomSheet({
  close,
}: DuplicateAccountsBottomSheetProps) {
  const navigation =
    useNavigation<StackNavigationProp<AppNavigatorParamsList>>();

  const handleLogin = useCallback(() => {
    close();
    Modal.close();
    navigation.navigate('LoginScreen');
  }, [navigation, close]);

  return (
    <Box>
      <Text
        variant="h4"
        color="darkSurfacePrimary"
        locKey="duplicateAccountsLabel"
        locNS="registration"
      />
      <Box gap="space-400" marginTop="space-400">
        <Text
          variant="body-m"
          color="darkSurfacePrimary"
          locKey="duplicateAccountsDescription"
          locNS="registration"
        />
        <Box flexDirection="row" justifyContent="space-between" gap="space-200">
          <Button
            variant="secondary"
            flex={1}
            locKey="duplicateAccountLoginButton"
            locNS="registration"
            onPress={handleLogin}
          />
        </Box>
      </Box>
    </Box>
  );
}

export default memo(DuplicateAccountsBottomSheet);
